define(['jquery'], function ($) {
  'use strict';

  class FotoramaExtend {
    constructor(element, config) { // eslint-disable-line
      this.fotorama = $(element);
      this.alpacaLoader = this.fotorama.find('[data-gallery-role="alpaca-loader"]');
      this.header = $('.header');
      this.gallery = null;

      this.init();
    }

    init() {
      this.fotorama.on('gallery:loaded', () => {
        this.gallery = this.fotorama.find('[data-gallery-role="gallery"]');
        this.fotorama.css('padding-bottom', '')

        this.gallery.find('.fotorama__stage__frame.fotorama__active')
          .one('f:load', () => {
            this.alpacaLoader.remove();
            this.fotorama.find('.fotorama__nav').css('display', '')
          });

        this.gallery.on('fotorama:fullscreenenter', () => {
          this.header.css('pointer-events', 'none');
        });

        this.gallery.on('fotorama:fullscreenexit', () => {
          setTimeout(() => {
            this.header.css('pointer-events', 'auto');
          })
        });
      })

      this.fotorama.on('gallery:error', (event, error) => {
        console.error('Gallery error:', error); // eslint-disable-line
      });
    }
  }

  return (config, element) => {
    new FotoramaExtend(element, config);
  };
});
